export default function AboutLeadership() {
  const leadership = [
    {
      name: "Leader Name 1",
      position: "Chief Executive Officer",
      image: "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1770035676/05ac8efab5b2a4229f94c8ab1428dd2f3d469e76_vv9ldh.png",
    },
    {
      name: "Leader Name 2",
      position: "Chief Operating Officer",
      image: "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1770036178/728bc5b8d3c690ed3ccbb4b418dabee542a9fda0_h4khwb.png",
    },
    {
      name: "Leader Name 3",
      position: "Chief Technical Officer",
      image: "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1770035656/e05bef24569e1430d68aea768cc225b00a504251_1_zz4stg.png",
    },
    {
      name: "Leader Name 4",
      position: "Chief Financial Officer",
      image: "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1770035658/b74a96725f7b6a8d6ba037d0d8ad666209cb7941_bcdcqw.png",
    },
  ];

  return (
    <section className="py-20 lg:py-32 bg-white" id="leadership">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-[1.2fr,2fr] gap-12 lg:gap-16 items-start">
          {/* Left side - Heading */}
          <div className="flex flex-col items-start justify-start">
            <p className="text-red-600 font-medium mb-4 text-lg uppercase tracking-wide">
              Management & leadership
            </p>
            <h2 className="text-3xl lg:text-[46px] font-medium text-slate-900 leading-tight">
              Meet the experts<br />in the field
            </h2>
          </div>

          {/* Right side - 2x2 Grid of team members */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {leadership.map((leader, index) => (
              <div 
                key={index} 
                className="group cursor-pointer"
              >
                <div className="bg-gray-200 overflow-hidden  flex items-center justify-center">
                  <img
                    src={leader.image}
                    alt={leader.name}
                    className="h-[380px] w-[320px] object-cover grayscale hover:grayscale-0 transition-all duration-300"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}